<template>
	<header class="public-header">
		<div class="public-header__logo">
			<RouterLink :to="{name: 'calculator'}">
				<img src="@/assets/spro-logo__dark.png" alt="Sentencing Pro" />
			</RouterLink>
		</div>
		<div class="public-header__meta">
		</div>
		<div class="public-header__nav">
			<ul class="public-header__items">
				<li class="public-header__item" @click="signOut" v-if="user">
					<i class="material-icons">logout</i>
				</li>
				<li class="public-header__item" v-else @click="signIn">
					Login
				</li>
			</ul>
		</div>
	</header>
	<div class="public-header__loading" :class="{'public-header__loading--loading': isLoading}">
		<LoadingLine />
	</div>
</template>

<script>
import { useMiscStore } from '@/lib/store/misc'
import { useUserStore } from '@/lib/store/user'

import LoadingLine from '@/components/LoadingLine.vue'

export default {
	name: 'PublicHeader',
	components: {
		LoadingLine,
	},
	setup() {
		const miscStore = useMiscStore()
		const userStore = useUserStore()

		return {
			miscStore,
			userStore,
		}
	},
	mounted() {
		this.userStore.checkUser()
			.catch(_ => {

			})
	},
	computed: {
		user() {
			return this.userStore.me
		},
		isLoading() {
			return this.miscStore.isLoading
		},
	},
	methods: {
		signIn() {
			this.$router.push({ name: 'login' })
		},
		signOut() {
			this.userStore.signOut()
			this.$router.push({name: 'login'})
		},
	},
}
</script>

<style scoped lang="scss">
.public-header {

	// background-color: var(--color--background);
	// box-shadow: 0 1px 4px 0 rgba(0,0,0,.12);
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
	padding: 0.5rem 1rem;
	position: relative;

	&__logo {
		align-items: center;
		display: flex;

		.material-icons {
			font-size: 40px;
			margin-right: 1rem;
		}

		h1 {
			font-size: 1.8rem;
			margin: 0;
			padding: 0;
		}

		img {
			max-height: 60px;
		}
	}

	&__title {
		margin: 0;
		padding: 0;

		@include modules.media-query('phone') {
			display: none;
		}
	}

	&__nav {
		// flex: 1;
		position: relative;
	}

	&__toggle {
		display: none;

		@include modules.media-query('phone') {
			display: block;
		}
	}

	&__items {
		display: flex;
		// display: grid;
		// grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
		// column-gap: 1rem;
		list-style-type: none;
		justify-content: space-between;
		margin: 0;
		padding: 0;
		width: 100%;
	}

	&__item {
		border-bottom: 2px solid transparent;
		cursor: pointer;
		margin-left: 1rem;
		padding: 0.25rem 0.25rem;

		@include modules.media-query('phone') {
			padding: 0.5rem 0.25rem;
			text-align: right;
		}

		&--active {
			&:not(.public-header__item--calculator) {
				border-bottom-color: var(--color--primary);
			}
		}

		&--exact-active {
			border-bottom-color: var(--color--primary);
		}
	}

	&__loading {
		position: sticky;
		width: 100%;
		left: 0;
		height: 4px;
		// bottom: 0;
		top: 0px;
		transition: opacity 150ms linear;
		opacity: 0;
		pointer-events: none;
		z-index: 11;

		&--loading {
			opacity: 1;
		}
	}
}

</style>
